// extracted by mini-css-extract-plugin
module.exports = {"overweightBaggage__flightInfo":"overweightBaggage__flightInfo-3Kt9r","overweightBaggage__fligntDirection":"overweightBaggage__fligntDirection-3ZW9P"};